module.exports = __webpack_public_path__ + "static/media/wind.20006e37.svg";